"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImplicitRedirectHandler = void 0;
const tsyringe_1 = require("tsyringe");
const fetchFactory_1 = require("../../../authenticatedFetch/fetchFactory");
let ImplicitRedirectHandler = class ImplicitRedirectHandler {
    constructor(tokenSaver, sessionInfoManager) {
        this.tokenSaver = tokenSaver;
        this.sessionInfoManager = sessionInfoManager;
    }
    async canHandle(redirectUrl) {
        try {
            const myUrl = new URL(redirectUrl);
            return (myUrl.searchParams.get("id_token") !== null &&
                myUrl.searchParams.get("access_token") !== null &&
                myUrl.searchParams.get("state") !== null);
        }
        catch (e) {
            throw new Error(`[${redirectUrl}] is not a valid URL, and cannot be used as a redirect URL: ${e.toString()}`);
        }
    }
    async handle(redirectUrl) {
        if (!(await this.canHandle(redirectUrl))) {
            throw new Error(`ImplicitRedirectHandler cannot handle [${redirectUrl}]: it is missing one or more of [id_token, access_token, state].`);
        }
        const url = new URL(redirectUrl);
        await this.tokenSaver.saveSession(url.searchParams.get("state"), url.searchParams.get("id_token"), url.searchParams.get("access_token"));
        const sessionId = url.searchParams.get("state");
        const sessionInfo = await this.sessionInfoManager.get(sessionId);
        return Object.assign(sessionInfo, {
            fetch: fetchFactory_1.buildBearerFetch(url.searchParams.get("access_token"), undefined),
        });
    }
};
ImplicitRedirectHandler = __decorate([
    tsyringe_1.injectable(),
    __param(0, tsyringe_1.inject("tokenSaver")),
    __param(1, tsyringe_1.inject("sessionInfoManager")),
    __metadata("design:paramtypes", [Object, Object])
], ImplicitRedirectHandler);
exports.ImplicitRedirectHandler = ImplicitRedirectHandler;
//# sourceMappingURL=ImplicitRedirectHandler.js.map